import React, { useEffect } from "react";
import debounce from "lodash-es/debounce";

import { useIsInvalid } from "../FormErrorsContext";
import { SelectOption } from "@admin/utils/types";
import Select from "react-select";
import { FoundModel } from "@admin/utils/misc";

type Props<T> = {
    inputName: string;
    label?: string;
    selectedEntityId?: number | string | null;
    selectedEntityTitle?: string | null;
    searchRequest: (query?: string) => Promise<T>;
    searchResultsHandler?: (payload: T) => SelectOption[];
    required?: boolean;
    placeholder?: string;
    isSearchable?: boolean;
};

export default function SearchInput<T>({
    selectedEntityId,
    selectedEntityTitle,
    inputName,
    label,
    searchRequest,
    searchResultsHandler,
    required = false,
    placeholder,
    isSearchable,
}: Props<T>) {
    const isInvalid = useIsInvalid(inputName);
    const [models, setModels] = React.useState<SelectOption[]>([]);

    // @ts-ignore
    searchResultsHandler ??= function <T extends FoundModel[]>(items: T): SelectOption[] {
        return items.map(
            ({ id, title }): SelectOption => ({
                value: id,
                label: title,
            }),
        );
    };

    const debouncedSearch = debounce((query: string): void => {
        if (query.length < 2) {
            return;
        }

        searchRequest(query).then((payload): void =>
            // @ts-ignore
            setModels(searchResultsHandler(payload)),
        );
    }, 500);

    useEffect((): void => {
        searchRequest().then((payload): void =>
            // @ts-ignore
            setModels(searchResultsHandler(payload)),
        );
    }, []);

    return (
        <div className="mb-5">
            {label && <label className="form-label">{label}</label>}

            <Select
                classNames={{
                    control: () => `form-control p-0` + (isInvalid ? ` is-invalid` : ``),
                }}
                placeholder={placeholder}
                onInputChange={debouncedSearch}
                defaultValue={
                    selectedEntityId
                        ? {
                              label: selectedEntityTitle,
                              value: selectedEntityId,
                          }
                        : undefined
                }
                name={inputName}
                required={required}
                options={models}
                isSearchable={isSearchable}
                isClearable
            />
        </div>
    );
}
